module.exports = __webpack_public_path__ + "img/flowers-7911617_1280.15756159.jpg";